import React, { Component } from 'react';
import PropTypes from 'prop-types';
import branch from 'client/core/branch';
import { withRouter } from 'react-router';

import ButtonDeprecated from 'client/components/ButtonDeprecated';

import AgentActions from 'client/actions/Agent';

@withRouter
@branch({
  viewingListing: ['agentMapView', 'viewingListing'],
  viewingRenter: ['agentMapView', 'viewingRenter'],
  viewingTour: ['agentMapView', 'viewingTour'],
  listing: ['listing'],
  agentUserId: ['agent', 'agentUserId'],
})
class SrAgentAddListingToTourButton extends Component {
  static propTypes = {
    listing: PropTypes.object,
    viewingListing: PropTypes.object,
    viewingRenter: PropTypes.object,
    viewingTour: PropTypes.object,
    agentUserId: PropTypes.number,
    disabled: PropTypes.bool,
    history: PropTypes.object,
  };

  _addToTour = () => {
    const {
      dispatch,
      listing,
      viewingListing,
      viewingRenter,
      history,
      agentUserId,
      viewingTour,
    } = this.props;
    dispatch(AgentActions.addListingToTour, {
      tourId: viewingTour.id,
      listingId: viewingListing ? viewingListing.id : listing.id,
      userId: viewingRenter.id,
      agentUserId,
    }).then(() => {
      history.push('/agent/tours');
    });
  };

  render() {
    const {
      viewingListing,
      viewingRenter,
      viewingTour,
      listing,
      disabled,
    } = this.props;

    const addToTourListing = viewingListing || listing;
    if (!addToTourListing || !viewingRenter || !viewingTour) {
      return null;
    }

    const userFirstName = viewingRenter.name.split(' ')[0];
    const listingsIdsInTour = viewingTour.listings.map(({ id }) => id);

    if (listingsIdsInTour.includes(addToTourListing.id)) {
      return null;
    }

    return (
      <ButtonDeprecated
        onClick={this._addToTour}
        disabled={disabled}
      >
        {`add to ${userFirstName.toLowerCase()}'s tour`}
      </ButtonDeprecated>
    );
  }
}

SrAgentAddListingToTourButton.displayName = 'SrAgentAddListingToTourButton';

export default SrAgentAddListingToTourButton;
